import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { kbApi, kbKeys, useKbSuggestion } from '@entities/knowledge';

/**
 * Синяя карточка экрана 3: «ИИ изучил базу знаний и предлагает дополнить инструкцию».
 * Появляется, когда обработана вся база; «Не сейчас» — скрыть до следующего обновления базы.
 */
export function KbSuggestionCard({
  assistantId,
  onAdd,
}: {
  assistantId: string;
  /** Пункты дописаны в инструкцию; signature — скрыть на сервере после «Сохранить». */
  onAdd: (items: string[], signature: string) => void;
}) {
  const qc = useQueryClient();
  const { data } = useKbSuggestion(assistantId);
  // Добавили в инструкцию, но ещё не сохранили: на сервере предложение не скрыто,
  // и повторная загрузка не должна вернуть карточку (пункты добавились бы дважды).
  const [addedSig, setAddedSig] = useState<string | null>(null);
  if (!data || data.dismissed || !data.items.length || !data.signature) return null;
  if (data.signature === addedSig) return null;
  const sig = data.signature;
  const hideHere = () =>
    qc.setQueryData(kbKeys.suggestion(assistantId), { ...data, dismissed: true });
  const hide = () => {
    hideHere();
    kbApi.dismissSuggestion(assistantId, sig).catch(() => undefined);
  };
  return (
    <section aria-labelledby="h-sugg" className="st-sugg">
      <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#2563EB"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M12 3l1.8 4.7L18.5 9.5l-4.7 1.8L12 16l-1.8-4.7L5.5 9.5l4.7-1.8z" />
        </svg>
        <h2 id="h-sugg" className="v2-h2">
          ИИ изучил базу знаний и предлагает дополнить инструкцию
        </h2>
      </div>
      <ul>
        {data.items.map((i) => (
          <li key={i}>{i}</li>
        ))}
      </ul>
      <div style={{ display: 'flex', gap: 8 }}>
        <button
          type="button"
          className="v2-btn is-primary"
          onClick={() => {
            // На сервере скрываем только после «Сохранить» — ушли без сохранения,
            // предложение вернётся.
            onAdd(data.items, sig);
            setAddedSig(sig);
            hideHere();
          }}
        >
          Добавить в инструкцию
        </button>
        <button type="button" className="v2-btn" style={{ borderColor: '#BFDBFE' }} onClick={hide}>
          Не сейчас
        </button>
      </div>
    </section>
  );
}
